import React from 'react';

import PropTypes from 'prop-types';

import { DividingLine } from 'components/DividingLine/DividingLine';
import { HistoricalMessage } from 'components/MyTaskArea/TaskDetailPage/CommentHistory/HistoricalMessage';
import { MessageType } from 'components/MyTaskArea/types';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './CommentHistory.sass';

export const CommentHistory = ({ messages, onDownloadAttachment }) => {
  if (!messages?.length) {
    return null;
  }

  const sortedMessages = [...messages].sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
  );

  return (
    <div className="comment-history">
      <SubTitle text="Nachrichtenverlauf" notFramed />
      {sortedMessages.map((message, index) => (
        <div key={message.id} className="comment-history__message">
          <HistoricalMessage message={message} onDownloadAttachment={onDownloadAttachment} />
          {index !== messages.length - 1 && <DividingLine />}
        </div>
      ))}
    </div>
  );
};

CommentHistory.propTypes = {
  messages: PropTypes.arrayOf(MessageType),
  onDownloadAttachment: PropTypes.func,
};

CommentHistory.defaultProps = {
  messages: [],
  onDownloadAttachment: () => {},
};
